
const pic=[
    {
        id:1,
        title:'3D modeling - The Forbidden City',
        converImg: require("../components/Card/Builiding.jpg"),
        url: "/model"
        
    },
    {
        id:2,
        title:'Youth Justice center VR application',
        converImg: require("../components/Card/center.jpg"),
        url:"/vr"
    },
    {
        id:3,
        title:'To-do List',
        converImg: require("../components/Card/Todo.png"),
        url:"/list"
    },
    {
        id:4,
        title:'Tenzies Game',
        converImg: require("../components/Card/game.jpeg"),
        url:"/game"
    },
    {
        id:5,
        title:'Image Search and Production ',
        converImg: require("../components/Card/Meme.png"),
        url:"/search"
    },
    // {
    //     id:6,
    //     title:'Small Calculator',
    //     converImg: require("../components/Card/Builiding.jpg"),
    //     url:"/calculator"
    // }
]
export default pic;